import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDisclosures } from "./useDisclosures";
import "./DisclosureStepSidebar.scss";

interface DisclosureStepSidebarProps {
  financialApplicationId: string;
}

export const DisclosureStepSidebar: React.FC<DisclosureStepSidebarProps> = ({
  financialApplicationId,
}) => {
  const { disclosures } = useDisclosures(financialApplicationId);

  return (
    <div className="disclosure-step-sidebar">
      <div className="disclosure-step-sidebar__content">
        {disclosures.length === 0 ? (
          <div className="disclosure-step-sidebar__empty">
            <p>No documents available yet.</p>
            <p>Documents will appear here as they become available.</p>
          </div>
        ) : (
          <div className="disclosure-step-sidebar__documents">
            <ul>
              {disclosures.map((disclosure) => (
                <li key={disclosure.slug}>
                  <div className="disclosure-step-sidebar__item-icon">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className={`disclosure-step-sidebar__item-icon-check ${disclosure.agreedSignedAt ? "disclosure-step-sidebar__item-icon-check-active" : ""}`}
                    />
                  </div>
                  <div className="disclosure-step-sidebar__item-label">
                    {disclosure.label}
                    {disclosure.agreedSignedAt && (
                      <div className="disclosures-info__agreed">
                        <small>
                          Agreed on {new Date(disclosure.agreedSignedAt).toLocaleDateString()}
                        </small>
                      </div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
